import type { ReactNode } from 'react'
import { Box } from '@n26/nxd'
import { Footer } from './Footer'
import styles from './AuthLayout.module.css'

type AuthLayoutProps = {
  children: ReactNode
}

export const AuthLayout = ({ children }: AuthLayoutProps) => (
  <Box className={styles.page} backgroundColor='neutral-alternate'>
    <Box as='main' className={styles.main}>
      <Box
        padding='24'
        borderRadius={{ mobile: '0', desktop: '16' }}
        backgroundColor='neutral'
        className={styles.card}
      >
        {children}
      </Box>
    </Box>
    <Footer />
  </Box>
)
